import React, {useState} from "react";
import {useEventManager, useUpdateEventManager} from "./useEventManager";
import TablePage from "../../pages/tablePage/TablePage";
import {useEventTable} from "./useEventTable";
import {Switch, Input, Tag} from "antd";
import ErrorPage from "../../shared/components/ErrorPage";


const EventManager = () => {
    const {data: eventList, isLoading: isEventListLoading, error: eventListError} = useEventManager();
    const {data: eventTable, isLoading: isEventTableLoading, error: eventTableError} = useEventTable();
    const updateEventManager = useUpdateEventManager();
    const [editingMemo, setEditingMemo] = useState({}); // { [seq]: memo }

    const columns = [
        {
            title: "이벤트ID",
            dataIndex: "eventId",
            key: "eventId",
        },
        {
            title: "이벤트명",
            dataIndex: "eventId",
            render: (_, {eventId}) => (
                <>
                    {eventTable?.[eventId]?.nameText || ''}({eventId}){' '}
                    {eventTable?.[eventId]?.difficultSet === 1 && (
                        <span style={{ color: 'green', fontWeight: 'bold' }}> [Easy]</span>
                    )}
                    {eventTable?.[eventId]?.difficultSet === 2 && (
                        <span style={{ color: 'red', fontWeight: 'bold' }}> [Hard]</span>
                    )}
                </>
            ),
            key: "eventName",
            width: '30%'
        },
        {
            title: "오픈 레벨",
            dataIndex: "eventId",
            render: (_, {eventId}) => (
                eventTable?.[eventId]?.openLevel || ''
            )
        },
        {
            title: '최소 적용 버전',
            dataIndex: 'minVersion',
            key: 'minVersion',
            render: (_, {eventId}) => (
                <Tag>{eventTable[eventId]?.openVersion || '테이블에 값을 넣어주세요.'}</Tag>
            )
        },
        {
            title: "목록 표시 여부",
            dataIndex: "isActive",
            key: "isActive",
            render: (isActive, record) => (
                <Switch
                    checked={!!isActive}
                    checkedChildren="On"
                    unCheckedChildren="Off"
                    onChange={checked => {
                        updateEventManager.mutate({
                            eventId: record.eventId,
                            isActive: checked ? 1 : 0,
                            memo: record.memo
                        });
                    }}
                />
            ),
        },
        {
            title: "메모",
            dataIndex: "memo",
            key: "memo",
            width: "30%",
            render: (memo, record) => (
                <Input
                    value={editingMemo[record.seq] !== undefined ? editingMemo[record.seq] : memo}
                    placeholder="입력후 엔터"
                    onChange={e => setEditingMemo(prev => ({...prev, [record.seq]: e.target.value}))}
                    onBlur={e => {
                        if (e.target.value !== memo) {
                            updateEventManager.mutate({
                                eventId: record.eventId,
                                isActive: record.isActive,
                                memo: e.target.value
                            });
                        }
                        setEditingMemo(prev => { const copy = {...prev}; delete copy[record.seq]; return copy; });
                    }}
                    onPressEnter={e => {
                        if (e.target.value !== memo) {
                            updateEventManager.mutate({
                                eventId: record.eventId,
                                isActive: record.isActive,
                                memo: e.target.value
                            });
                        }
                        setEditingMemo(prev => { const copy = {...prev}; delete copy[record.seq]; return copy; });
                    }}
                    size="small"
                />
            )
        },
    ];

    const isLoading = isEventListLoading || isEventTableLoading;
    const firstError = eventListError || eventTableError;
    if (firstError) return <ErrorPage error={firstError}/>;

    const props = {
        columns,
        localData: eventList || [],
        loading: isLoading,
        title: "이벤트 목록 관리"
    }
    return (
        <TablePage
            {...props}
        />
    );
};

export default EventManager;
